import { render, staticRenderFns } from "./SelectStatusAutoClaim.vue?vue&type=template&id=59d626cb&scoped=true&"
import script from "./SelectStatusAutoClaim.vue?vue&type=script&lang=js&"
export * from "./SelectStatusAutoClaim.vue?vue&type=script&lang=js&"
import style0 from "./SelectStatusAutoClaim.vue?vue&type=style&index=0&id=59d626cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d626cb",
  null
  
)

export default component.exports